export const AccessManagementFlags = {
  VisitorManagementHostEmailVerifiedCheck:
    'squad-access-management.visitor-management-host-email-verified-check',
  VisitorManagementEmailWorkflowGrpcRetry:
    'squad-access-management.visitor-management-email-workflow-grpc-retry',
  EnableVMBulkActions: 'squad-access-management.enable-vm-bulk-actions',
  VisitorManagementDisplayAllBulkActionStatuses:
    'squad-access-management.visitor-management-display-all-bulk-action-statuses',
  AllowSuperUserAccessAdmin:
    'squad-access-management.allow-super-user-access-admin',
  UseServerSidePagination: 'squad-access-management.use-server-side-pagination',
  TenantConfigurationEnhancements:
    'squad-access-management.tenantConfigurationEnhancements',
  UseTenantsAccessIntegrations:
    'squad-access-management.use-tenants-access-integrations',
  MobileKeycardListUpdated:
    'squad-access-management.mobile-keycard-list-updated',
  EnableACIMHidV2: 'squad-access-management.activate.mobile.acim.hid.v2',
  AccessConfigurationPage: 'squad-access-management.access-configuration',
  AccessConfigurationPageDefaultAccess:
    'squad-access-management.access-configuration.default-access',
  EnableAccessMobileHIDV1DDLogging:
    'squad-access-management.activate.mobile.hid.v1.enable.dd.logging',
  MobileAccessGlobalKeycards: 'squad-access-management.v5.41.global.keycard',
  MobileAccessGlobalKeycardsExcludeIntegration:
    'squad-access-management.global.keycard.exclude.integration',
  MobileAccessHidGoogleWalletCardStatus:
    'squad-access-management.hid.google.wallet.card.status',
  MobileAccessGlobalKeycardHidSession:
    'squad-access-management.global.keycard.hid.session',
  MobileAccessGallagherSdkEnableDebugLog:
    'squad-access-management.gallagher.sdk.enable.debug.log',
  MobileAccessHidGoogleWalletActivePassByOrganizationName:
    'squad-access-management.hid.google.wallet.activepass.by.organizationname',
  MobileAccessGlobalKeycardsTier1:
    'squad-access-management.global.keycard.tier1',
  KastleAppleWalletCardStatus:
    'squad-access-management.kastle.apple.wallet.card.status',
  OfficeManagerText: 'squad-integrations-management.hid-office-manager-text',
  AccessControlAccessCredentials:
    'squad-integrations-management.access-control-access-credentials',
  RemoveBuildingUser: 'squad-integrations-management.remove-building-user',
  InviteAddUserSeparation:
    'squad-integrations-management.invite-add-user-separation',
  AccessLaneRefactor: 'squad-integrations-management.access-lane-refactor',
  AccessKeycard: 'squad-integrations-management.key-card',
  NewBuildingAccessPage:
    'squad-integrations-management.new-building-access-page',
  VisitorManagementWatchlistV2:
    'squad-access-management.visitor-management-watchlist-v2',
  VisitorManagementWatchlistRestrictAtTenant:
    'squad-access-management.visitor-management-watchlist-restrict-at-tenant',
  VisitorManagementWatchlistExportChannelName:
    'squad-access-management.visitor-management-watchlist-export-channel-name',
  SquadAccessManagementAccessControlEnableMobileAccessOnJoinDelayMs:
    'squad-access-management.access-listener-delay',
  SquadAccessManagementAccessControlEnableMobileAccessOnJoinMaxRetries:
    'squad-access-management.access-listener-retries',
  VisitorManagementWatchlistApprovalMessage:
    'squad-access-management.visitor-management-watchlist-approval-message',
  // Rogue flags
  SquadIntegrationsManagementAccessControlEnableMobileAccessOnJoin:
    'squad-integrations-management.access-control-enable-mobile-access-on-join',
  SquadIntegrationsManagementSkipRevokeCredentialsOnDeleteFromProvider:
    'squad-integrations-management.skip-revoke-credentials-on-delete-from-provider',
  SquadIntegrationsManagementV5CredentialGroups:
    'squad-integrations-management.v5-credential-groups',
  SquadAccessManagementActivateMobileHidBackgroundModeDisabled:
    'squad-access-management.activate.mobile.hid.background.mode.disabled',
  SquadAccessManagementBackFillCredentialMappingTypes:
    'squad-access-management.back-fill-credential-mapping-types',
  SquadAccessManagementDisableCredentials:
    'squad-access-management.disable-credentials',
  SquadAccessManagementEnableWithUserMappings:
    'squad-access-management.enable-with-user-mappings',
  SquadAccessManagementUserAccessDetailsNew:
    'squad-access-management.user-access-details-new',
  // Rogue flags end
  VisitorManagementBoundedRRuleSchedule:
    'squad-access-management.visitor-management-bounded-rrule-schedule',
  GetChannelUsersOptimization:
    'squad-access-management.get-channel-users-optimization',
  InviteBuildingDefaultAcgPrefill: 'squad-access-management.invite-building-default-acg-prefill',
  VisitorManagementUseBatchHostQuery:
    'squad-access-management.visitor-management-use-batch-host-query',
  VisitorManagementVisitorRegHostNameSelectionFix: 'squad-access-management.vm-visitor-registration-host-name-selection-fix',
  VisitorManagementDisplayVtsCredentialID: 'squad-access-management.visitor-management-display-vts-credential-id',
  EndpointAuthorizationEnforcement:
    'squad-access-management.endpoint-authorization-enforcement',
  FixVisitorManagementIcsCalendarRendering:
    'squad-access-management.fix-visitor-management-ics-calendar-rendering',
  MobileAccessModalAdminFix:
    'squad-access-management.mobile-access-modal-admin-fix',
  DisableVisitorUpdatePayloadValidation:
    'squad-access-management.disable-visitor-update-payload-validation',
  VisitorManagementReducedBulkUploadLimit:
    'squad-access-management.vm-reduced-bulk-upload-limit',
} as const;
